module.exports = __webpack_public_path__ + "img/contacLogo.23b5bed2.png";